/**
 * Visual values used across the Inbox preview cards that don't map to a theme
 * token. Keep them here so the previews stay visually consistent and there's a
 * single place to tweak them.
 */

/** Corner radius of the preview cards (no 20px token exists in the theme). */
export const CARD_RADIUS = '20px'

/** Elevation shared by every preview card. */
export const CARD_SHADOW = `
  0 0 1px 0 rgba(0, 0, 0, 0.15),
  0 4px 8px 0 rgba(0, 0, 0, 0.05),
  0 1px 1px 0 rgba(0, 0, 0, 0.05)
`

/** Hairline outline around the asset icon tile. */
export const HAIRLINE_SHADOW = '0 0 0 1px hsla(0, 0%, 0%, 0.07)'

/** Frosted-glass breadcrumb overlay sitting on top of the canvas image. */
export const GLASS_BLUR = '15px'

/** Notch cut into the comment thread card so it tucks under the canvas image. */
export const NOTCH_CLIP_PATH =
  "path('M 0 12 C 6 12, 12 0, 15 0 C 18 0, 24 12, 30 12 Z')"

/** Square size of the asset icon / document thumbnail tiles. */
export const TILE_MEDIA_SIZE = '96px'

/**
 * Single-key shortcuts for the preview action buttons. Each key is hinted on
 * its button and registered via `useInboxActionShortcut` while the button is
 * shown. Keep them lowercase — they're matched against `event.key` and
 * uppercased for display.
 */
export const ACTION_SHORTCUTS = {
  pin: 'p',
  seeDocument: 'o',
  openInvite: 'o',
  download: 'd',
  accept: 'a',
  unfollow: 'u',
} as const
